import { absolutePath } from "./absolutePath";

const BASE_PATH = "connect/connection/requests";

interface IndexParams {
  page?: number;
  per_page?: number;
}

export const connectionRequests = {
  index: (params: IndexParams = {}) => absolutePath(BASE_PATH, params),
};
